import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    getCustomers (countryId,cityId) {
        return axios.get('/api/customers/list', { params: {countryId:countryId,cityId:cityId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomersByCategory (countryId,cityId, category) {
        return axios.get('/api/customers/list/category', { params: {countryId:countryId,cityId:cityId, category:category} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllCustomers (filter , page, pageSize,countryId,cityId) {
        return axios.get('/api/customers/custmerslist', { params: {  filter: filter,page: page, pageSize: pageSize, countryId:countryId,cityId:cityId} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getCountCustomers(){
        return axios.get('/api/customers/count/customers')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOutstandingInfo () {
        return axios.get('/api/customers/outstandingInfo')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveFilePDF(formData,id){
        return axios.post("/api/customers/uploadPaymentConditions/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.customer.save'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadPaymentConditions(fileName){
        axios({
            url:'/api/customers/getPaymentConditions',
            method: 'GET',
            params: {fileName:fileName } ,
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();
          });
    },

    getCustomerCurrency(){
        return axios.get('/api/customers/currency')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}

